/*
 * Geo
 *
 * Allow the tracking of the users location. Send lat and lon with all requests
 *
 */

Foundation.Mobile.Geo = function (options) {
    if (typeof options == "undefined") {
        options = {};
    }
    // function to call when location is made avalible

    if (options['on_success']) {
        this.on_success_callback = options['on_success']
    }
    if (options['on_request']) {
        this.on_request_callback = options['on_request']
    }
    if (options['on_failure']) {
        this.on_failure_callback = options['on_failure']
    }
    if (options['position']) {
        this.default_position = options['position'];
    }


    if (Foundation.Mobile.Geo.instance) {
        // Only allow initilization code to run once.
        return Foundation.Mobile.Geo.instance;
    }

    // set this for use in the handleQuery function
    this.isFirstRun = "true";

    // If a position is passed to this function use this as the default
    if (typeof this.default_position != "undefined") {
        var position = this.default_position;
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        this.execute_callbacks(this.on_success_callback);
    }
    else {
        // Initialize the geolocation
        this.gl = navigator.geolocation;

        if (!this.gl) {
            this.locationUnavailable = true;
            this.execute_callbacks(this.on_failure_callback);
        }
    }

    Foundation.Mobile.Geo.instance = this;
    return Foundation.Mobile.Geo.instance;
}

Foundation.Mobile.Geo.instance = undefined;

Foundation.Mobile.Geo.prototype.execute_callbacks = function (callback, arg) {
    if (typeof callback == "function") {
        callback.call(this, arg);
    }
};


Foundation.Mobile.Geo.prototype.updatePosition = function () {
    if (this.defaultPosition) {
        // default position is being used so jump straigth to the handler.
        this.handleQuery(this.defaultPosition);
    }
    else if (Foundation.Mobile.Cookies.getItem('gyrobase-latitude')) {
        // the cookies have not timed out and so we don't need to query the location
        var stale_pos = {};
        stale_pos.coords = {};
        stale_pos.coords.latitude = Foundation.Mobile.Cookies.getItem('gyrobase-latitude');
        stale_pos.coords.longitude = Foundation.Mobile.Cookies.getItem('gyrobase-longitude');

        this.handleQuery(stale_pos);
    }
    else {
        this.getPosition()
    }
};

Foundation.Mobile.Geo.prototype.getPosition = function () {
    this.execute_callbacks(this.on_request_callback);
    if (this.gl) {
        this.gl.getCurrentPosition(this.handleQuery.bind(this), this.handleError.bind(this));
    }
    else {
        this.locationAvalible = false;
        this.execute_callbacks(this.on_failure_callback, {code: 2});
    }
}

Foundation.Mobile.Geo.prototype.handleQuery = function (position) {
    this.latitude = position.coords.latitude;
    this.longitude = position.coords.longitude;
    this.locationAvalible = true;
    this.execute_callbacks(this.on_success_callback, position);
}

Foundation.Mobile.Geo.prototype.handleError = function (error) {
    this.locationAvalible = false;
    this.execute_callbacks(this.on_failure_callback, error);
}


window["Foundation"]["Mobile"]["Geo"] = Foundation.Mobile.Geo;
